import axiosFactory from "./axios.factory";

class ShippingDataService {
  // Schlanker Artikelstamm (SKU, Name, Zustand) fuer Auswahlfelder - einmal laden, lokal suchen
  async getProductLookup() {
    const result = await axiosFactory().get("/shipping_data/products/lookup");
    return result.data.data || [];
  }

  async getRecordStatuses() {
    const result = await axiosFactory().get("/shipping_data/record_statuses");
    return result.data.data;
  }

  async getRecordTags() {
    const result = await axiosFactory().get("/shipping_data/record_tags");
    return result.data.data;
  }

  // Stickerverwaltung (Trello 26.08.2026): Anlegen/Bearbeiten nur noch ueber den Dialog
  async createRecordTag(payload) {
    const result = await axiosFactory().post("/shipping_data/record_tags", payload);
    return result.data.data;
  }

  async updateRecordTag(id, payload) {
    const result = await axiosFactory().put(`/shipping_data/record_tags/${id}`, payload);
    return result.data.data;
  }

  async getSupplierNames() {
    const result = await axiosFactory().get("/shipping_data/supplier_names");
    return result.data.data;
  }

  async getContainerSizes() {
    const result = await axiosFactory().get("/shipping_data/container_sizes");
    return result.data.data;
  }

  async getContainerArrivalPlaces() {
    const result = await axiosFactory().get("/shipping_data/container_arrival_places");
    return result.data.data;
  }

  async getCarrierNames() {
    const result = await axiosFactory().get("/shipping_data/carrier_names");
    return result.data.data;
  }

  async getPaymentStatuses() {
    const result = await axiosFactory().get("/shipping_data/payment_statuses");
    return result.data.data;
  }

  async getShipmentPaidStatuses() {
    const result = await axiosFactory().get("/shipping_data/shipment_paid_statuses");
    return result.data.data;
  }

  async getCustomsPaidStatuses() {
    const result = await axiosFactory().get("/shipping_data/customs_paid_statuses");
    return result.data.data;
  }

  async getChinaStatuses() {
    const result = await axiosFactory().get("/shipping_data/china_statuses");
    return result.data.data;
  }

  async getLinkedProducts() {
    const result = await axiosFactory().get("/shipping_data/linked_products");
    return result.data.data;
  }

  async getChinaUsers() {
    const result = await axiosFactory().get("/shipping_data/china_users");
    return result.data.data;
  }

  async getAccountingStatuses() {
    const result = await axiosFactory().get("/shipping_data/accounting_statuses");
    return result.data.data;
  }

  async createSupplier(opts) {
    const result = await axiosFactory().post("/shipping_data/suppliers", opts);
    return result.data.data;
  }

  async editSupplier(opts) {
    const result = await axiosFactory().put("/shipping_data/suppliers", opts);
    return result.data.data;
  }

  async createProduct(opts) {
    const result = await axiosFactory().post("/shipping_data/products", opts);
    return result.data.data;
  }

  async editProduct(opts) {
    const result = await axiosFactory().put("/shipping_data/products", opts);
    return result.data.data;
  }

  async getProducts({ keywords }) {
    const result = await axiosFactory().get("/shipping_data/products?keywords=" + keywords);
    return result.data.data;
  }
  async getProductSKUs(params) {
    const result = await axiosFactory().get("/shipping_data/products", { params });
    return result.data.data;
  }

  async getShippingStatuses() {
    const result = await axiosFactory().get("/orders/shipping_statuses");
    return result.data.data;
  }

  async getCarriers() {
    const result = await axiosFactory().get("/shipping_data/carriers");
    // return result.data.data;
    const carrierItems = structuredClone(result.data.data) || [];

    carrierItems.push({ id: -1, name: "orders.speditionWithoutNumbers" });
    carrierItems.forEach((carrier) => {
      switch (carrier.id) {
        case 1:
          carrier.logo = "/img/logo-dhl.png";
          break;
        case 2:
          carrier.logo = "/img/logo-dpd.png";
          break;
        case 3:
          carrier.logo = "/img/logo-speedition.png";
          break;
        case 4:
          carrier.logo = "/img/logo-multi.png";
          break;
        case -1:
          carrier.logo = "/img/logo-speedition-without-number.png";
          break;
        default:
          carrier.logo = null;
      }
    });
    return carrierItems;
  }
}

export default new ShippingDataService();
